document.addEventListener("DOMContentLoaded", () => {
    const header = document.getElementById("main-header");
    const facetanim = document.getElementById("main-collection-filters") || document.getElementById("main-search-filters");

    if (header && facetanim) {
      const headerInitialOffset = header.offsetTop;
      let lastScrollY = window.scrollY;
      let ticking = false;
      let keepVisible = false;

      function onScroll() {
          const currentScrollY = window.scrollY;

          if (currentScrollY > headerInitialOffset) {
            if (!keepVisible) {
              if (currentScrollY > lastScrollY) {
                facetanim.classList.remove("fix");
              } else {
                facetanim.classList.add("fix");
              }
            }
          } else {
            facetanim.classList.remove("fix");
            keepVisible = false;
          }

          lastScrollY = currentScrollY;
          ticking = false;
      }

      window.addEventListener("scroll", () => {
          if (!ticking) {
            window.requestAnimationFrame(onScroll);
            ticking = true;
          }
      });
    }
    });


    document.querySelectorAll(".filter-item").forEach((item, index) => {
        const button = item.querySelector(".filter-toggle");
        const content = item.querySelector(".filter-content");
      
        // ouverture du premier filtre APRÈS le rendu Shopify
        if (index === 0) {
          item.classList.add("is-open");
      
          requestAnimationFrame(() => {
            content.style.maxHeight = content.scrollHeight + "px";
            content.style.opacity = "1";
          });
        }
      
        button.addEventListener("click", (e) => {
          e.preventDefault();
          e.stopPropagation();
          e.stopImmediatePropagation();
      
          const isOpen = item.classList.contains("is-open");
      
          item.classList.toggle("is-open");
      
          if (!isOpen) {
            content.style.maxHeight = content.scrollHeight + "px";
            content.style.opacity = "1";
          } else {
            content.style.maxHeight = "0";
            content.style.opacity = "0";
          }
        }, true);
      });
      
      // sécurité : recalcul si Shopify recharge les filtres (AJAX)
      document.addEventListener("shopify:section:load", () => {
        const first = document.querySelector(".filter-item");
        if (first) {
          const content = first.querySelector(".filter-content");
          first.classList.add("is-open");
          content.style.maxHeight = content.scrollHeight + "px";
          content.style.opacity = "1";
        }
      });